import { clsx } from '@alexis/helpers/clsx';
import { range } from 'lodash-es';
import React from 'react';

import styles from '../FlightFilters.module.scss';

const FlightFiltersSkeleton: React.FC = () => {
  return (
    <>
      {range(3).map((value: number) => (
        <React.Fragment key={value}>
          <div className={clsx(styles.categoryHeader, value !== 0 && styles.withTopMargin)}>
            <div className={styles.skeleton}></div>
          </div>

          <div className={styles.categoryContent}>
            <div className={styles.item}>
              <div className={clsx(styles.checkbox, styles.skeleton)}></div>
              <div className={styles.skeleton}></div>
            </div>
          </div>

          <div className={styles.categoryContent}>
            <div className={styles.item}>
              <div className={clsx(styles.checkbox, styles.skeleton)}></div>
              <div className={clsx(styles.skeleton, styles.large)}></div>
            </div>
          </div>

          <div className={styles.categoryContent}>
            <div className={styles.item}>
              <div className={clsx(styles.checkbox, styles.skeleton)}></div>
              <div className={styles.skeleton}></div>
            </div>
          </div>

          <div className={styles.categoryContent}>
            <div className={styles.item}>
              <div className={clsx(styles.checkbox, styles.skeleton)}></div>
              <div className={clsx(styles.skeleton, styles.large)}></div>
            </div>
          </div>
        </React.Fragment>
      ))}
    </>
  );
};

export default FlightFiltersSkeleton;
